// extracted by mini-css-extract-plugin
module.exports = {"recommendedProductTitle":"recommendedProductsTitle-module__recommendedProductTitle___3Ng6N"};